import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// Home redirect ke login; about/terms/jobs/layanan/hubungi kami dll redirect ke login (LMS STIKSAM)
const pageRoutes = [
  <Route
    key="home"
    exact
    path="/"
    render={() => <Redirect to="/login" />}
  />,
  <Route key="about" exact path="/about" render={() => <Redirect to="/login" />} />,
  <Route key="terms" exact path="/terms" render={() => <Redirect to="/login" />} />,
  <Route key="jobs" exact path="/jobs" render={() => <Redirect to="/login" />} />,
  <Route key="mitra" exact path="/mitra" render={() => <Redirect to="/login" />} />,
  <Route key="mentor" exact path="/mentor" render={() => <Redirect to="/login" />} />,
  <Route key="mau-jadi-mentor" exact path="/mau-jadi-mentor" render={() => <Redirect to="/login" />} />,
  <Route key="regulasi" exact path="/regulasi" render={() => <Redirect to="/login" />} />,
  <Route key="farmasi" exact path="/farmasi" render={() => <Redirect to="/login" />} />,
  <Route key="teknologi" exact path="/teknologi" render={() => <Redirect to="/login" />} />,
  <Route key="uji" exact path="/uji" render={() => <Redirect to="/login" />} />,
  <Route key="contact" exact path="/contact" render={() => <Redirect to="/login" />} />,
  <Route key="privacy-policy" exact path="/privacy_policy" render={() => <Redirect to="/login" />} />
];

export default pageRoutes;
